import BlockLeftImage from "../components/BlockLeftImage";

import FlipCard from "../components/Flipcard";
import imagenacero from "../img/ingenieria/imagen_acero.png";
import HeroSection from "../components/HeroSection";
import Comites from "../components/Comites";
import Registro from "../components/Registro/Registro.js";
import edwin from "../img/ingenieria/edwin.png";
import eva from "../img/ingenieria/eva.png";
import carlos from "../img/ingenieria/carlos.png";
import nati from "../img/ingenieria/natividad.png";
import matias from "../img/ingenieria/matias.png";
import paul from "../img/ingenieria/paul.png";
import sergio from "../img/ingenieria/sergio2.png";
import asociacion from "../img/ingenieria/logomarca.png";
import Inscripciones from "../components/Inscripciones";
import SpeakersSection from "../components/SpeakerCard.js";
import FixedHeader from "../components/FixedHeader";
import videoportada from "../img/ingenieria/videoportada.mp4";

function Home() {
  const lineasInvestigacion = [
    "Análisis estructural teórico, computacional y experimental",
    "Estructuras de acero, concreto, madera y materiales compuestos",
    "Sismo-resistencia, acciones térmicas, viento, fuego e impacto",
    "Patología, reforzamiento y rehabilitación estructural",
    "Instrumentación, monitoreo y control de estructuras",
    "Vida útil, confiabilidad y desempeño estructural",
    "Diseño y construcción de puentes, torres y edificaciones",
    "Innovación tecnológica en ingeniería estructural",
  ];

  return (
    <>
      <FixedHeader video={videoportada}> </FixedHeader>
      <HeroSection></HeroSection>

      <div className="relative">
        <div className="bg2">
          <BlockLeftImage
            content={
              <>
                <h2>
                  Líneas <b>temáticas</b>
                </h2>

                <ol className="lista-estilizada">
                  {lineasInvestigacion.map((item, index) => (
                    <li key={index}>
                      <p>{item}</p>
                    </li>
                  ))}
                </ol>
              </>
            }
            src={imagenacero}
            alt="utpl"
          ></BlockLeftImage>
        </div>{" "}
      </div>

      <div className="bg3 padding ">
        <div className="layout8">
          <h2 className="width700">
            <b> Explora las últimas tendencias en </b>innovación tecnológica e
            ingeniería estructural
          </h2>
        </div>

        <div className="padding">
          <div className="layout8 ">
            <center>
              <h3>
                Speakers <b>reconocidos</b>
              </h3>
              <p></p>
            </center>{" "}
          </div>
          <div className=" speakers flex-center" id="ponentes">
            <FlipCard
              src={eva}
              content={
                <>
                  <h2>Ph. D. Eva Lantsoght</h2>

                  <p>
                    Es Vicedecana de Investigación y Profesora Principal Titular
                    de Ingeniería Estructural en la Universidad San Francisco de
                    Quito. Profesora Asociada de Estructuras de Hormigón en la
                    Technische Universiteit Delft y Profesora Invitada en la
                    División de Ingeniería Estructural de Luleå University of
                    Technology.
                  </p>
                  <p>
                    {" "}
                    Es miembro del Comité Ejecutivo de IABMAS y fue galardonada
                    con el Premio Junior de IABMAS 2020 en reconocimiento a sus
                    contribuciones al campo de la ingeniería de puentes. Además,
                    es Fellow del American Concrete Institute, recibió el Premio
                    Mete A. Sozen 2024 del ACI a la Excelencia en Investigación
                    Estructural, y es Vicepresidenta de IABSE, la Asociación
                    Internacional de Ingeniería de Puentes y Estructuras.
                  </p>
                </>
              }
            ></FlipCard>{" "}
            <FlipCard
              src={matias}
              content={
                <>
                  <h2>Ph. D. Matías Andrés Valenzuela Saavedra</h2>

                  <p>
                    Especialista en infraestructura vial, diseño estructural y
                    resiliencia. Ingeniero Civil por la Universidad de Chile y
                    Doctor en Ingeniería de la Construcción por la Universitat
                    Politècnica de Catalunya (España), con calificación
                    Excelente Cum Laude.
                  </p>
                  <p>
                    Académico en la Pontificia Universidad Católica de
                    Valparaíso (PUCV) y Director del CEAL–Escuela de Gobierno.
                    Cuenta con más de 18 años de experiencia en infraestructura
                    de gran escala, gestión del riesgo de desastres y adaptación
                    al cambio climático.
                  </p>
                  <p>
                    Ha sido asesor estructural del Ministerio de Obras Públicas
                    de Chile, participando en proyectos emblemáticos como el
                    Puente Chacao. Actualmente se desempeña como Secretario
                    Regional Ministerial de Transporte y Telecomunicaciones en
                    Valparaíso. Miembro activo de IABSE e IABMAS y autor de
                    publicaciones en resiliencia de infraestructura.
                  </p>
                </>
              }
            ></FlipCard>{" "}
            <FlipCard
              src={sergio}
              content={
                <>
                  <h2>Ph. D. Sergio Gavilán</h2>

                  <p>
                    Doctor en Ingeniería Civil en el Área de Estructuras por la
                    Universidad Federal de Rio Grande do Sul (Brasil) e
                    Ingeniero Civil por la Facultad de Ingeniería de la
                    Universidad Nacional de Asunción (FIUNA), donde se desempeña
                    como Profesor y miembro del Grupo de Investigación de
                    Ingeniería Estructural. Ex presidente de la APE (Asociación
                    Paraguaya de Estructuras). Director de Gavilán & Asociados y
                    de LEMCO (Laboratorio de Ensayos de Materiales y Control de
                    Obras). Perito Judicial, con más de 25 años de experiencia
                    en evaluación, diagnóstico y refuerzo de estructuras de
                    hormigón armado, ha intervenido en obras emblemáticas como
                    el Estadio Defensores del Chaco, el Congreso Nacional, el
                    Aeropuerto Internacional Silvio Pettirossi, así como la
                    evaluación de más de 100 puentes.
                  </p>
                </>
              }
            ></FlipCard>{" "}
            <FlipCard
              src={edwin}
              content={
                <>
                  <h2>Ph. D. Edwin Duque</h2>

                  <p>
                    Ingeniero Civil especializado en modelación numérica y
                    análisis/diseño sismo-resistente de estructuras. Título de
                    Ingeniero Civil por la Universidad Técnica Particular de
                    Loja (Ecuador) y Máster en Ciencias de la Ingeniería,
                    mención Estructuras y Geotecnia, por la Universidad Nacional
                    de Córdoba (Argentina).
                  </p>
                  <p>
                    Revisor principal del capítulo Guadua Estructural de la
                    Norma Ecuatoriana de la Construcción (NEC-2015). Miembro de
                    la ASAEE, director del Grupo de Investigación de Ingeniería
                    Sísmica y Sismología de la UTPL (GRISS-UTPL) y coordinador
                    del Observatorio Sísmico del Ecuador (OSSE).
                  </p>
                  <p>
                    Docente en la UTPL en las cátedras de Resistencia de
                    Materiales, Estructuras I-II, Dinámica de Suelos, Concreto
                    I-II y Análisis Dinámico de Estructuras.
                  </p>
                </>
              }
            ></FlipCard>
            <FlipCard
              src={carlos}
              content={
                <>
                  <h2>Mgtr. Carlos Celi</h2>

                  <p>
                    Es ingeniero estructural con maestría (Summa Cum Laude) de
                    la Escuela Politécnica Nacional y más de 17 años de
                    experiencia, destacándose en consultorías de edificios de
                    gran altura (más de 170 m). Actualmente forma parte del
                    Departamento de Ingeniería Civil de la Pontificia
                    Universidad Católica del Ecuador. Su investigación se centra
                    en la modelación matemática no lineal, con diversas
                    publicaciones científicas internacionales. Trabaja en
                    proyectos relacionados con inteligencia artificial aplicada
                    a sismología, análisis de amenaza sísmica en Ecuador, redes
                    neuronales para estimación de fragilidad estructural y
                    generación de acelerogramas sintéticos, además de colaborar
                    en iniciativas internacionales sobre evaluación del riesgo
                    sísmico.
                  </p>
                </>
              }
            ></FlipCard>
            <FlipCard
              src={nati}
              content={
                <>
                  <h2>Ph. D. Natividad García Troncoso</h2>

                  <p>
                    Docente investigadora en materiales de construcción e
                    ingeniería estructural, especializada en hormigón y
                    soluciones sostenibles. Coordinadora de la Maestría en
                    Estructuras Civiles Sismorresistentes en la ESPOL y
                    vicepresidenta de IABSE Ecuador.
                  </p>
                  <p>
                    Doctora por Imperial College London, con maestría en la
                    Universidad de León y pregrado en la ESPOL. Su trayectoria
                    se centra en compuestos cementicios y sistemas
                    estructurales, incluyendo hormigones de alto desempeño,
                    materiales ligeros, autocompactantes, bahareque y hormigón
                    reforzado con fibras.
                  </p>
                  <p>
                    Lidera el laboratorio de estructuras FICT-ESPOL y dirige el
                    grupo GeoSMIT, impulsando investigación aplicada, formación
                    de investigadores y vinculación con la sociedad.
                  </p>
                </>
              }
            ></FlipCard>
            <FlipCard
              src={paul}
              content={
                <>
                  <h2>Ph. D. Paúl Guerrero</h2>

                  <p>
                    Ingeniero civil especializado en rehabilitación estructural,
                    graduado en la ESPE (Ecuador), con experiencia en diseño,
                    construcción y rehabilitación de edificaciones y obras
                    civiles. Actualmente lidera la gestión de I+D en AYP
                    INGENSERVI y SIBHIALTA Cía. Ltda., desarrollando proyectos
                    de vivienda, infraestructura educativa e industrial. Ha
                    colaborado con empresas como SANTOS CMI (Ecuador) y POSCO EC
                    (Corea del Sur), y ha sido docente de posgrado en la UTPL.
                  </p>
                  <p>
                    Cuenta con formación de posgrado en geotecnia, estructuras,
                    ingeniería sísmica, cimentaciones, rehabilitación, gestión
                    de proyectos y administración, además de doctorados en
                    Matemáticas y Proyectos, enfocados en evaluación
                    estructural.
                  </p>
                  <p>
                    Participó en la Norma Ecuatoriana de la Construcción (NEC) y
                    orienta su investigación a la seguridad estructural y
                    sostenibilidad en contextos vulnerables.
                  </p>
                </>
              }
            ></FlipCard>
          </div>
        </div>
      </div>

      <Inscripciones></Inscripciones>


      <Comites></Comites>
      <div className="bg4 ">
        <div className="layout8">
          <center>
            <h4>Organizan</h4>

            <p>Departamento de Ingeniería Civil, Arquitectura y Geociencias</p>
            <p>
              Grupo de Investigación en Ingeniería sísmica y sismología
              GRISS-UTPL
            </p>

            <h4>En alianza con</h4>
            <p> Asociación Sudamericana de Ingeniería Estructural (ASAEE)</p>
            <div className="icon100">
              {" "}
              <img src={asociacion}></img>
            </div>
          </center>
        </div>
      </div>
    </>
  );
}

export default Home;
